import Cookies from 'js-cookie';
import Plyr from 'plyr';

import { externalSourcesBanner } from './ExternalSourcesBanner';

const playerElements = Array.from(document.querySelectorAll('.player'));

if (Cookies.get('AllowExternalServices') === 'true') {
  const players = playerElements.map((p) => {
    const iframe = p.querySelector('iframe');
    iframe.src = iframe.dataset.src;
    return new Plyr(p, {
      controls: ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'fullscreen'],
      ratio: '16:9',
      iconUrl: '/wp-content/themes/kinder-und-lernen-template/assets/public/plyr.svg',
      youtube: {
        noCookie: true
      }
    });
  });
} else {
  Array.from(document.querySelectorAll('.player')).forEach(player => {
    externalSourcesBanner(player);
  });
}
